import { Injectable } from "@angular/core";
import { AgenteRepository } from "../app.domain.repository/agente.repository";
import { GenericEntityService } from "../core.utilidades/generic-entity.service";
import { Agente } from "../app.domain.models/agente";


@Injectable({
    providedIn: 'root',
})
export class AgenteApiService extends AgenteRepository implements GenericEntityService<Agente> { }